import { useEffect } from 'react'
import './ImageLightbox.css'

export default function ImageLightbox({ imageUrl, alt, onClose }) {
  // Handle escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    // Prevent body scroll while lightbox is open
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [onClose])

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <button
        className="lightbox-close"
        onClick={onClose}
        aria-label="Close"
      >
        &times;
      </button>
      <div className="lightbox-content" onClick={e => e.stopPropagation()}>
        <img src={imageUrl} alt={alt || 'Full size image'} />
      </div>
    </div>
  )
}
